import Dialog from '@mui/material/Dialog';
import React, { useState, useEffect } from 'react';
import {
  ButtonWrapper,
  CancelButton,
  DataGridContainer,
  DialogHeader,
  DialogHeading,
  GridContainer,
  LeftGrid,
  SaveButton,
} from '../../../Episode/Episode.Styled';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FormInputDropdown from '../../../common/Forms/FormDropdown';
import FormInputText from '../../../common/Forms/FormTextField';
import FormInputMultiCheckbox from '../../../common/Forms/FormCheckbox';
import Grid from '@mui/material/Grid';
import { useForm, useWatch } from 'react-hook-form';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import {
  setCboDefaultWeeklyQty,
  setCboRteAmt,
  setCboRteCmt,
  setCboRteDcpAmt,
  setCboRteDcpMthSettlementYn,
  setCboRteDcpQty,
  setCboRteDcpUnitAmt,
  setCboRteEndMthId,
  setCboRteStartMthId,
  setCboRteTargetPct,
  setCboRteTmtTypId,
  setCbpCnyMnRte,
  setCbpCnyMxRte,
  setCbpRteInactive,
} from '../../../../redux/cbp/cbpRates/cbpRatesFormSlice';
import {
  CBP_RATES_LIST,
  commonDecimalText,
  fieldRequired,
  noNegitiveValue,
} from '../../../../constants';
import { postStopApi, setStopApi } from '../../../../services/StopApi/StopApi';
import FormSuccess from '../../../common/Forms/FormSuccess';
import { DialogDivider } from '../../../ui/styled';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const schema = yup.object().shape({
  Start: yup.string().required(fieldRequired),
  End: yup.string().required(fieldRequired),
  TmtType: yup.string().required(fieldRequired),
  Amount: yup
    .number()
    .typeError(fieldRequired)
    .required(fieldRequired)
    .min(0, noNegitiveValue),

/**
  DARSApprovedCountRteMn: yup
    .number()
    .typeError(fieldRequired)
    .required(fieldRequired)
    .min(0, noNegitiveValue),
  DARSApprovedCountRteMx: yup
    .number()
    .typeError(fieldRequired)
    .required(fieldRequired)
    .min(0, noNegitiveValue),
  UnitsPerDay: yup
    .number()
    .typeError('This field is in intiger format.')
    .min(0, noNegitiveValue)
    .integer('This field is in intiger format.'),
  UnitsPerWeek: yup
    .number()
    .typeError('This field is in intiger format.')
    .min(0, noNegitiveValue)
    .integer('This field is in intiger format.'),
  TotalUnits: yup
    .number()
    .typeError('This field is in intiger format.')
    .min(0, noNegitiveValue)
    .integer('This field is in intiger format.'),
  TotalAmount: yup
    .number()
    .typeError(fieldRequired)
    .required(fieldRequired)
    .min(0, noNegitiveValue),
  UtilizationReq: yup
    .number()
    .typeError(fieldRequired)
    .required(fieldRequired)
    .min(0, noNegitiveValue),
  Comment: yup
    .string()
    .typeError(fieldRequired)
    .required(fieldRequired)
    .max(256, 'This field should not exceed 256 characters'),
**/
});

const CBPRatesDialog = (props) => {
  const dispatch = useDispatch();
  const {
    open,
    setOpen,
    openBackdrop,
    authToken,
    fetchData,
    cbpRateInvoices,
    setCBPRateInvoices,
    cbpId,
  } = props;
  const cbpdecimal = cbpRateInvoices?.data?.map(
    (item) => +item.invoiceAmount.split('$')[1]
  );
  const cbpTotalInvoices = cbpdecimal?.reduce(
    (prev, current) => prev + current,
    0
  );
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewCbpRatesAlert, setIsNewCbpRatesAlert] = useState(false);
  const cbpRatesFormData = useSelector((state) => state.cbpRatesFormData);
  const cbpRatesReferenceData = useSelector((state) => state.cbpReferenceData);
  const defaultValue = {
    Start: cbpRatesFormData?.Start,
    End: cbpRatesFormData?.End,
    TmtType: cbpRatesFormData?.TmtType,
    Amount: cbpRatesFormData?.Amount,
    DARSApprovedCountRteMn: cbpRatesFormData?.DARSApprovedCountRteMn,
    DARSApprovedCountRteMx: cbpRatesFormData?.DARSApprovedCountRteMx,
    UnitsPerDay: cbpRatesFormData?.UnitsPerDay,
    UnitsPerWeek: cbpRatesFormData?.UnitsPerWeek,
    TotalUnits: cbpRatesFormData?.TotalUnits,
    TotalAmount: cbpRatesFormData?.TotalAmount,
    UtilizationReq: cbpRatesFormData?.UtilizationReq,
    RateInactive: cbpRatesFormData?.RateInactive,
    MonthlySettlement: cbpRatesFormData?.MonthlySettlement,
    Comment: cbpRatesFormData?.Comment,
  };
  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, register, formState } = useFunction;
  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.Start,
    defaultValue.End,
    defaultValue.TmtType,
    defaultValue.Amount,
    defaultValue.DARSApprovedCountRteMn,
    defaultValue.DARSApprovedCountRteMx,
    defaultValue.UnitsPerDay,
    defaultValue.UnitsPerWeek,
    defaultValue.TotalUnits,
    defaultValue.TotalAmount,
    defaultValue.UtilizationReq,
    defaultValue.RateInactive,
    defaultValue.MonthlySettlement,
    defaultValue.Comment,
  ]);

  const Start = useWatch({
    control,
    name: 'Start',
  });

  const End = useWatch({
    control,
    name: 'End',
  });

  const TmtType = useWatch({
    control,
    name: 'TmtType',
  });

  useEffect(() => {
    dispatch(setCboRteStartMthId(Start));
    dispatch(setCboRteEndMthId(End));
    dispatch(setCboRteTmtTypId(TmtType));
  }, [Start, End, TmtType]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = () => {
    const url = `${CBP_RATES_LIST}/${cbpId}/rte`;
    const authorization = authToken;
    if (cbpRatesFormData?.newCbpRates === true) {
      const payload = {
        CBPRteID: cbpRatesFormData?.CBPRteID,
        CboID: cbpId,
        Start: cbpRatesFormData?.Start === '' ? null : cbpRatesFormData?.Start,
        End: cbpRatesFormData?.End === '' ? null : cbpRatesFormData?.End,
        TmtType:
          cbpRatesFormData?.TmtType === '' ? null : cbpRatesFormData?.TmtType,
        Amount:
          cbpRatesFormData?.Amount === '' ? null : cbpRatesFormData?.Amount,
        DARSApprovedCountRteMn:
          cbpRatesFormData?.DARSApprovedCountRteMn === ''
            ? null
            : cbpRatesFormData?.DARSApprovedCountRteMn,
        DARSApprovedCountRteMx:
          cbpRatesFormData?.DARSApprovedCountRteMx === ''
            ? null
            : cbpRatesFormData?.DARSApprovedCountRteMx,
        UnitsPerDay:
          cbpRatesFormData?.UnitsPerDay === ''
            ? null
            : parseInt(cbpRatesFormData?.UnitsPerDay),
        UnitsPerWeek:
          cbpRatesFormData?.UnitsPerWeek === ''
            ? null
            : parseInt(cbpRatesFormData?.UnitsPerWeek),
        TotalUnits:
          cbpRatesFormData?.TotalUnits === ''
            ? null
            : parseInt(cbpRatesFormData?.TotalUnits),
        TotalAmount:
          cbpRatesFormData?.TotalAmount === ''
            ? null
            : cbpRatesFormData?.TotalAmount,
        UtilizationReq:
          cbpRatesFormData?.UtilizationReq === ''
            ? null
            : cbpRatesFormData?.UtilizationReq,
        RateInactive:
          cbpRatesFormData?.RateInactive === ''
            ? null
            : cbpRatesFormData?.RateInactive,
        MonthlySettlement:
          cbpRatesFormData?.MonthlySettlement === ''
            ? null
            : cbpRatesFormData?.MonthlySettlement,
        Comment:
          cbpRatesFormData?.Comment === '' ? null : cbpRatesFormData?.Comment,
      };
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewCbpRatesAlert(true);
        }
      }).catch((e) => alert(e));
    } else {
      const payload = {
        CBPRteID: cbpRatesFormData?.CBPRteID,
        CboID: cbpRatesFormData?.CboID,
        Start: cbpRatesFormData?.Start,
        End: cbpRatesFormData?.End,
        TmtType: cbpRatesFormData?.TmtType,
        Amount: cbpRatesFormData?.Amount,
        DARSApprovedCountRteMn: cbpRatesFormData?.DARSApprovedCountRteMn,
        DARSApprovedCountRteMx: cbpRatesFormData?.DARSApprovedCountRteMx,
        UnitsPerDay: cbpRatesFormData?.UnitsPerDay,
        UnitsPerWeek: cbpRatesFormData?.UnitsPerWeek,
        TotalUnits: cbpRatesFormData?.TotalUnits,
        TotalAmount: cbpRatesFormData?.TotalAmount,
        UtilizationReq: cbpRatesFormData?.UtilizationReq,
        RateInactive: cbpRatesFormData?.RateInactive,
        MonthlySettlement: cbpRatesFormData?.MonthlySettlement,
        Comment: cbpRatesFormData?.Comment,
      };
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
        }
      }).catch((e) => alert(e));
    }
    setOpen(false);
  };

  const columnsData = [
    {
      field: 'CBPInvID',
      headerName: 'CBP InvID',
    },
    {
      field: 'month',
      headerName: 'Month',
      sortable: false,
    },
    {
      field: 'allocatedUnits',
      headerName: 'Allocated Units',
      sortable: false,
    },
    {
      field: 'allocatedCumltvUnits',
      headerName: 'Allocated Cumltv Units',
      sortable: false,
    },
    {
      field: 'allocatedAmount',
      headerName: 'Allocated Amount',
      sortable: false,
    },
    {
      field: 'utilizationReqBpaDcp',
      headerName: 'Utilization Req. Bpa/Dcp%',
      sortable: false,
      width: 120,
    },
    {
      field: 'utilizationReqUnits',
      headerName: 'Utilization Req. units',
      sortable: false,
    },
    {
      field: 'utilizationReqCumltvUnits',
      headerName: 'Utilization Req. Cumilitive Units',
      sortable: false,
      width: 120,
    },
    {
      field: 'actualTotalUnits',
      headerName: 'Actual Total Units',
      sortable: false,
    },
    {
      field: 'actualCumltiveUnits',
      headerName: 'Actual Cumltive Units',
      sortable: false,
      width: 120,
    },
    {
      field: 'invoiceAmount',
      headerName: 'Invoice Amount',
      sortable: false,
    },
  ];

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '800px',
            maxHeight: '90vh',
            '&::-webkit-scrollbar': { display: 'none' },
          },
        }}
      >
        {openBackdrop ? (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            <DialogHeader>
              <DialogHeading variant='h5'>CBP Rates</DialogHeading>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </DialogHeader>
            <Box style={{ padding: '10px 40px' }}>
              <Grid
                container
                spacing={2}
                //style={{ padding: '10px 40px', marginTop: '0px' }}
              >
                <Grid item xs={12} sm={6}>
                  <FormInputDropdown
                    name='Start'
                    control={control}
                    options={cbpRatesReferenceData?.months}
                    label='Rate Term Start'
                    isDate={true}
                    errors={!!errors.Start}
                    helperText={errors?.Start?.message}
                  />
                  <FormInputDropdown
                    name='End'
                    control={control}
                    options={cbpRatesReferenceData?.months}
                    label='Rate Term End'
                    isDate={true}
                    errors={!!errors.End}
                    helperText={errors?.End?.message}
                  />
                  <FormInputDropdown
                    name='TmtType'
                    control={control}
                    options={cbpRatesReferenceData?.tmtTypes}
                    label='Tmt Type'
                    errors={!!errors.TmtType}
                    helperText={errors?.TmtType?.message}
                  />
                  <FormInputText
                    name='Amount'
                    control={control}
                    label='Amount'
                    type='number'
                    minValue={0}
                    errors={!!errors.Amount}
                    helperText={errors?.Amount?.message}
                    register={register('Amount', {
                      onChange: (e) => dispatch(setCboRteAmt(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='DARSApprovedCountRteMn'
                    control={control}
                    label='DARS approved County Rte Mn'
                    type='number'
                    minValue={0}
                    errors={!!errors.DARSApprovedCountRteMn}
                    helperText={errors?.DARSApprovedCountRteMn?.message}
                    register={register('DARSApprovedCountRteMn', {
                      onChange: (e) => dispatch(setCbpCnyMnRte(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='DARSApprovedCountRteMx'
                    control={control}
                    label='DARS approved County Rte Mx'
                    type='number'
                    minValue={0}
                    errors={!!errors.DARSApprovedCountRteMx}
                    helperText={errors?.DARSApprovedCountRteMx?.message}
                    register={register('DARSApprovedCountRteMx', {
                      onChange: (e) => dispatch(setCbpCnyMxRte(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='UnitsPerDay'
                    control={control}
                    label='# Units Per Day'
                    type='number'
                    minValue={0}
                    errors={!!errors.UnitsPerDay}
                    helperText={errors?.UnitsPerDay?.message}
                    register={register('UnitsPerDay', {
                      onChange: (e) =>
                        dispatch(setCboRteDcpUnitAmt(e.target.value)),
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormInputText
                    name='UnitsPerWeek'
                    control={control}
                    label='# Units Per Week'
                    type='number'
                    minValue={0}
                    errors={!!errors.UnitsPerWeek}
                    helperText={errors?.UnitsPerWeek?.message}
                    register={register('UnitsPerWeek', {
                      onChange: (e) =>
                        dispatch(setCboDefaultWeeklyQty(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='TotalUnits'
                    control={control}
                    label='Total Units'
                    type='number'
                    minValue={0}
                    errors={!!errors.TotalUnits}
                    helperText={errors?.TotalUnits?.message}
                    register={register('TotalUnits', {
                      onChange: (e) =>
                        dispatch(setCboRteDcpQty(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='TotalAmount'
                    control={control}
                    label='Total Amount'
                    type='number'
                    minValue={0}
                    errors={!!errors.TotalAmount}
                    helperText={errors?.TotalAmount?.message}
                    register={register('TotalAmount', {
                      onChange: (e) =>
                        dispatch(setCboRteDcpAmt(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='UtilizationReq'
                    control={control}
                    label='Utilization Req %'
                    type='number'
                    minValue={0}
                    errors={!!errors.UtilizationReq}
                    helperText={errors?.UtilizationReq?.message}
                    register={register('UtilizationReq', {
                      onChange: (e) =>
                        dispatch(setCboRteTargetPct(e.target.value)),
                    })}
                  />
                  <FormInputText
                    name='Comment'
                    control={control}
                    label='comment'
                    multiline={true}
                    rows={3}
                    errors={!!errors.Comment}
                    helperText={errors?.Comment?.message}
                    register={register('Comment', {
                      onChange: (e) => dispatch(setCboRteCmt(e.target.value)),
                    })}
                  />
                  <FormInputMultiCheckbox
                    control={control}
                    name='RateInactive'
                    label='Rate Inactive'
                    checked={defaultValue.RateInactive}
                    register={register('RateInactive', {
                      onChange: (e) =>
                        dispatch(setCbpRteInactive(e.target.value)),
                    })}
                  />
                  <FormInputMultiCheckbox
                    control={control}
                    name='MonthlySettlement'
                    label='Monthly Settlement'
                    checked={defaultValue.MonthlySettlement}
                    register={register('MonthlySettlement', {
                      onChange: (e) =>
                        dispatch(setCboRteDcpMthSettlementYn(e.target.value)),
                    })}
                  />
                </Grid>
              </Grid>
              <ButtonWrapper>
                <CancelButton variant='contained' onClick={handleClose}>
                  Cancel
                </CancelButton>
                <SaveButton
                  variant='contained'
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </SaveButton>
              </ButtonWrapper>
            </Box>
            {cbpRatesFormData?.newCbpRates === true ? (
              ''
            ) : (
              <>
                <DialogDivider variant='middle' />
                <Grid container style={{ padding: '0px 40px' }}>
                  <GridContainer container>
                    <Grid item xs={6}>
                      <DialogHeading variant='h5'>
                        CBP Rates Invoices
                      </DialogHeading>
                    </Grid>
                    <LeftGrid item xs={6}></LeftGrid>
                  </GridContainer>
                  <Grid item xs={12}>
                    <DataGridContainer>
                      <DataGrid
                        getRowHeight={() => 'auto'}
                        columns={columnsData}
                        rows={cbpRateInvoices.data}
                        page={cbpRateInvoices.page - 1}
                        rowCount={cbpRateInvoices.total}
                        rowsPerPageOptions={[10, 25, 50]}
                        pageSize={cbpRateInvoices.pageSize}
                        pagination
                        paginationMode='server'
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? 'even'
                            : 'odd'
                        }
                        onPageSizeChange={(newPageSize) =>
                          setCBPRateInvoices((prveState) => ({
                            ...prveState,
                            pageSize: newPageSize,
                          }))
                        }
                        onPageChange={(newPage) => {
                          setCBPRateInvoices((prveState) => ({
                            ...prveState,
                            page: newPage + 1,
                          }));
                        }}
                        loading={cbpRateInvoices.isLoading}
                        //onRowClick={(param) => cbpCaseManagerRowClick(param.row)}
                        disableColumnFilter
                        disableColumnMenu
                      />
                    </DataGridContainer>
                  </Grid>
                  <Grid item xs={12}></Grid>
                  <GridContainer container>
                    <Grid item xs={6}></Grid>
                    <LeftGrid item xs={6}>
                      <Typography variant='h5'>
                        Total Invoices Amount: ${cbpTotalInvoices}
                      </Typography>
                    </LeftGrid>
                  </GridContainer>
                </Grid>
              </>
            )}
          </>
        )}
      </Dialog>
      <FormSuccess
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        isNewForm={isNewCbpRatesAlert}
      />
    </>
  );
};

export default CBPRatesDialog;
